module.exports = __webpack_public_path__ + "img/pp-37.16225263.jpg";